<template>
    <div class="ffa-event-item">
        <a v-bind:href="item.Url" target="_blank">
            <div v-if="item.Image" class="ffa-img">
                <img v-bind:src="item.Image">
            </div>
        </a>
        <div class="ffa-event-item-content">
            <h3>
                <a v-bind:href="item.Url" target="_blank">
                    {{ item.City }}, {{ item.State }}
                </a>
            </h3>
            <template v-if="item.Venue">
                <p class="ffa-venue">
                    {{ item.Venue }}
                </p>
            </template>
            <template v-if="!item.DateTBD">
                <p class="ffa-title">
                    {{ formatDateRange(item.StartDate, item.EndDate) }}
                </p>
            </template>
            <template v-else>
                <p class="ffa-title">
                    TBD
                </p>
            </template>
            
            <p>
                <a v-bind:href="item.Url" class="cta-link" target="_blank">
                    Register
                </a>
            </p>
        </div>
    </div>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';

	export default {
		props: ['item'],
		components: {

		},
		mounted: function () {
			
		},
		methods: {
			formatDate(date) {
				return DateFormatService.formatDate(date);
			},
			formatDateRange(start, end) {
				return DateFormatService.formatDateRange(start, end);
			},
        },
    }
</script>